import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '../../common/Button';
import { constants } from '../../common/constants/constants';
import { GAEvent } from '../../common/google_analytics/google_analytics';
import Close from '../../images/newDesign/closeBlack.svg';
import { StyledHeaderMessage } from './HeaderMessage.styled';

const HeaderMessage = ({ onCloseClick, buildingID }) => {
    const { t } = useTranslation();
    const history = useHistory();

    const onLearnMoreClick = () => {
        GAEvent(constants.GoogleAnalytics.Events.learnMore, 'learnMore', 1, 'learnMore');
        GAEvent(constants.GoogleAnalytics.Events.clicks, 'learnMore', 1, 'learnMore');
        history.push({pathname: `/${constants.pages.learnMore}/${buildingID}`})
    };

    return (
        <StyledHeaderMessage>
           {t('payments.installments_available')}
           <Button onClick={onLearnMoreClick}>{t('payments.learn_more')}</Button>

           <img src={Close} className='close-btn' onClick={onCloseClick} />
        </StyledHeaderMessage>
    )
}

export default HeaderMessage;
